export const fileStatus = {
    NO_FILE: "NO_FILE",
    UPLOADING: "UPLOADING",
    COMPLETED: "COMPLETED"
  }